import script from "./SfxSearchBarQuick.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxSearchBarQuick.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
